import { RefObject, useEffect } from 'react';

export type UseHandleClickOutsideArgs = {
  containerRef: RefObject<HTMLDivElement | null>;
  isOpen: boolean;
  onClose: () => void;
};

export function useHandleClickOutside({
  containerRef,
  isOpen,
  onClose,
}: UseHandleClickOutsideArgs): void {
  useEffect(() => {
    if (!isOpen) {
      return;
    }

    const handleOutsideClick = (event: MouseEvent) => {
      const target = event.target as HTMLElement;

      if (containerRef.current && !containerRef.current.contains(target)) {
        onClose();
      }
    };

    document.addEventListener('mousedown', handleOutsideClick);

    return () => {
      document.removeEventListener('mousedown', handleOutsideClick);
    };
  }, [containerRef, isOpen, onClose]);
}
